module.exports = __webpack_public_path__ + "6a5d973500309f5326753e0f8faaca32.svg";